import _plugin_vue_export_helper_default from "../../_virtual/_plugin-vue_export-helper.js";
import ResponseBodyPreview_vue_vue_type_script_setup_true_lang_default from "./ResponseBodyPreview.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                                        */
//#region src/components/ResponseBody/ResponseBodyPreview.vue
var ResponseBodyPreview_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ResponseBodyPreview_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-92f84612"]]);
//#endregion
export { ResponseBodyPreview_default as default };

//# sourceMappingURL=ResponseBodyPreview.vue.js.map